import React from 'react';
import { AlertTriangle, Archive, ArchiveRestore, CheckCircle, Info, ShieldAlert } from 'lucide-react';
import { AppNotification, NotificationSeverity } from '../types/notifications';
interface NotificationCardProps {
  notification: AppNotification;
  onMarkRead: (id: number) => void;
  onArchive: (id: number) => void;
  onRestore: (id: number) => void;
}
const SEVERITY_ICON: Record<NotificationSeverity, React.ReactNode> = {
  critical: <ShieldAlert size={18} className="text-[#DB3725]" data-id="element-1549" data-mp="3h8ol62iw4abh" />,
  warning: <AlertTriangle size={18} className="text-yellow-600" data-id="element-1550" data-mp="3m6zsa5hsw6q0" />,
  info: <Info size={18} className="text-[#30718D]" data-id="element-1551" data-mp="3q9mmue5uw5qw" />,
  success: <CheckCircle size={18} className="text-[#007558]" data-id="element-1552" data-mp="3qa5u90xvrbqo" />
};
export function NotificationCard({
  notification,
  onMarkRead,
  onArchive,
  onRestore
}: NotificationCardProps) {
  return <article className="flex flex-col gap-2 px-4 py-4 sm:flex-row sm:items-start sm:gap-4 sm:px-6" data-id="element-1553" data-mp="1vwwsxwfhmwji">
      <span className="mt-0.5 hidden flex-none sm:block" aria-hidden="true" data-id="element-1554" data-mp="20vhkz8kl69wv">
        {SEVERITY_ICON[notification.severity]}
      </span>

      <div className="min-w-0 flex-1" data-id="element-1555" data-mp="3rlxzksnvl2zu">
        <div className="flex items-start gap-2" data-id="element-1556" data-mp="3mt4prqdjv4gw">
          <span className="mt-0.5 flex-none sm:hidden" aria-hidden="true" data-id="element-1557" data-mp="3mra94o9b9yim">
            {SEVERITY_ICON[notification.severity]}
          </span>
          <h3 className={`text-sm text-gray-900 sm:text-base ${notification.read ? 'font-medium' : 'font-bold'}`} data-id="element-1558" data-mp="3dthqba4ds8qh">
            {notification.title}
          </h3>
          {!notification.read && !notification.archived && <span className="mt-2 h-2 w-2 flex-none rounded-full bg-[#DB3725]" aria-label="Unread" data-id="element-1559" data-mp="a9vg4p6cyarw" />}
        </div>
        <p className="mt-1 text-sm leading-relaxed text-gray-600" data-id="element-1560" data-mp="cqv4so90lco">
          {notification.message}
        </p>
        <p className="mt-2 text-xs text-gray-400" data-id="element-1561" data-mp="2q4p1ryq3935w">
          {notification.source} · {notification.timestamp}
        </p>
      </div>

      <div className="-ml-2 flex flex-none items-center gap-1 sm:ml-0" data-id="element-1562" data-mp="2l6drjmvvsqn5">
        {notification.archived ? <button onClick={() => onRestore(notification.id)} aria-label={`Restore: ${notification.title}`} title="Restore" className="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700" data-id="element-1563" data-mp="2rkavv9t8s0gg">
            <ArchiveRestore size={16} aria-hidden="true" data-id="element-1564" data-mp="2ilpgfnj2h1jw" />
          </button> : <>
            {!notification.read && <button onClick={() => onMarkRead(notification.id)} aria-label={`Mark as read: ${notification.title}`} title="Mark as read" className="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-[#007558]" data-id="element-1565" data-mp="28lovjx5juddl">
                <CheckCircle size={16} aria-hidden="true" data-id="element-1566" data-mp="1kx5otm25e8nm" />
              </button>}
            <button onClick={() => onArchive(notification.id)} aria-label={`Archive: ${notification.title}`} title="Archive" className="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700" data-id="element-1567" data-mp="1ptw62cpovaam">
              <Archive size={16} aria-hidden="true" data-id="element-1568" data-mp="1g8cyw7l6qid8" />
            </button>
          </>}
      </div>
    </article>;
}